import { authApiService } from '@/api/authApiService';
import { ApiParams } from '@/api/helpers/apiHelpers';
import { ApiResponseType } from '@/types/sharedTypes';

export const exportAuditEventsApi = (params?: ApiParams): Promise<ApiResponseType<Blob>> => {
  return authApiService.GET('/audit-log/events/export/', params);
};
